<script setup lang="ts">
import type { TutorLegalSelectFieldProps } from '../../model/legal/tutor-legal-select-field.hook'

import { RowSlot } from '@shared/ui/other'
import { NativeSelect } from '@shared/ui/fields'

import { useTutorLegalSelectField } from '../../model/legal/tutor-legal-select-field.hook'

defineOptions({
  name: 'TutorLegalSelectField',
})

const props = defineProps<TutorLegalSelectFieldProps>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const {
  refNativeOptions,
  refMode,
  setValue,
} = useTutorLegalSelectField({
  props,
  onUpdate: (value: string) => emit('update:modelValue', value),
})
</script>

<template>
  <RowSlot :label="label">
    <NativeSelect
      :name="name"
      :options="refNativeOptions"
      :value="modelValue || null"
      :mode="refMode"
      :placeholder="placeholder"
      placeholder-enabled
      @change="setValue"
    />
  </RowSlot>
</template>
